import { useEffect } from 'react';

import { UtmTrackingService } from '../services/utm-tracking.service';

export const useUtmTracking = () => {
  useEffect(() => {
    // Initialize UTM tracking when the component mounts
    UtmTrackingService.updateUtmData();
  }, []);

  return {
    getUtmData: () => UtmTrackingService.getUtmDataForApi(),
    hasUtmParams: () => UtmTrackingService.hasUtmParams(),
    clearUtmData: () => UtmTrackingService.clearUtmData(),
  };
};
